import { flow } from 'lodash';
import withPager from '../../hocs/Pager';
import withUserInput from '../../hocs/UserInput';
import SwipeCards from './SwipeCards';

export default flow(withPager, withUserInput)(SwipeCards);



// WEBPACK FOOTER //
// ../core/src/components/SwipeCards/index.js